import { memo } from "react"
import { Col, Container, Row } from "react-bootstrap"
import OIBuildUp from "./OIBuildUp"
import PutCallRatio from "./PutCall"

const FutureOption = ({scripOverviewData}) =>{
    return(
        <>
        <Container fluid className='p-0 mt-5'>
            <Row className='g-0'>
                <Col md={6} className='pe-3'>
                    <PutCallRatio/>
                </Col>
                <Col md={6} className='ps-3'>
                    <OIBuildUp scripOverviewData={scripOverviewData}/>
                </Col>
            </Row>            
        </Container>
        </>
    )
}
export default memo(FutureOption)